import type { TemplateTheme } from '@mfec/lit/TemplateResolver';
import { Config } from '@mfec/types/tefComs';
import normalizeUrl from 'normalize-url';

export interface InjectExternalResourcesOptions {
  config : Config;
  parentElement: HTMLElement | DocumentFragment;
  theme: TemplateTheme;
  themeBaseUrl: string;
  onErrorHandler?: EventListenerOrEventListenerObject;
  onLoadHandler?: EventListenerOrEventListenerObject;
}

export const injectExternalResources = ({
  config,
  parentElement,
  theme,
  themeBaseUrl,
  onErrorHandler,
  onLoadHandler,
} : InjectExternalResourcesOptions) : void => {
  const themeConfig = config.theme[theme];
  if (!themeConfig) return;

  const resources = themeConfig.resources.map((r) => r.path);
  let $element : HTMLElement;

  resources.forEach((resource) => {
    // eslint-disable-next-line sonarjs/unused-named-groups
    const resourceTypeMatch = /\.(?<resourceType>(?:css|js))(?:$|\?|#)/.exec(resource);
    if (!resourceTypeMatch) return;
    const { resourceType } = resourceTypeMatch.groups as { resourceType: string };
    const resourceUrl = normalizeUrl(`${themeBaseUrl}/${resource}`);

    if (resourceType === 'js') {
      $element = document.createElement('script');
      $element.setAttribute('src', resourceUrl);
      $element.setAttribute('type', 'module');
    } else if (resourceType === 'css') {
      $element = document.createElement('link');
      $element.setAttribute('rel', 'stylesheet');
      $element.setAttribute('href', resourceUrl);
      $element.setAttribute('as', 'style');
    } else {
      return;
    }

    $element.setAttribute('fetchpriority', 'high');
    if (onLoadHandler) {
      $element.addEventListener('load', onLoadHandler);
    }
    if (onErrorHandler) {
      $element.addEventListener('error', onErrorHandler);
    }

    parentElement.appendChild($element);
  });
};
